/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-subscribe.vue?vue&type=template&id=332094ce&scoped=true&"
import script from "./authorize-subscribe.vue?vue&type=script&lang=js&"
export * from "./authorize-subscribe.vue?vue&type=script&lang=js&"
import style0 from "./authorize-subscribe.vue?vue&type=style&index=0&id=332094ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332094ce",
  null
  
)

export default component.exports